export default __webpack_public_path__ + "static/media/mag.3594a294.svg";